import {idListIncludes} from '../components/optimizely/gdi/utils/gdi-id-list'

/**
 * Resolves the GDISizeGuidesBlock that covers the product's c_sizeChartWeb
 * attribute. Shared by the PDP SizeChartDrawer and the quick view size chart so
 * both are populated with (and gated by) the same CMS content.
 *
 * Structure:
 *   optimizelyContent.item.SizeGuides[]
 *     → ContentLink.Expanded (GDISizeGuidesBlock)
 *       → CategoryId: "gar-tops-size-chart_alphabetical" — or a comma-separated
 *         list when one guide serves several size charts
 *       → GDISizeGuidesBlockContent[]: content area items
 */

/**
 * @param {Array} sizeGuides - The SizeGuides array from optimizely content.
 * @param {string} sizeChartId - The product's c_sizeChartWeb attribute value.
 * @returns {Object|null} The matched SizeGuides entry, or null.
 */
export const resolveSizeGuide = (sizeGuides, sizeChartId) => {
    if (!Array.isArray(sizeGuides) || !sizeChartId) return null
    return (
        sizeGuides.find((entry) =>
            idListIncludes(entry?.ContentLink?.Expanded?.CategoryId, sizeChartId)
        ) ?? null
    )
}

/**
 * @param {Array} sizeGuides - The SizeGuides array from optimizely content.
 * @param {string} sizeChartId - The product's c_sizeChartWeb attribute value.
 * @returns {Array} The matched block's content items, or an empty array.
 */
export const resolveSizeGuideBlocks = (sizeGuides, sizeChartId) => {
    const match = resolveSizeGuide(sizeGuides, sizeChartId)
    return match?.ContentLink?.Expanded?.GDISizeGuidesBlockContent ?? []
}
